export default function PricingHero({ billingCycle, onToggle }) {
  return (
    <section className="relative overflow-hidden pt-[180px] pb-[80px] px-6 lg:px-10 bg-blue-primary-900 text-white text-center">
      {/* Background radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,rgba(0,56,112,0.5),transparent_70%)]" />

      <div className="relative z-10 max-w-[740px] mx-auto fade-in">
        <div className="inline-block bg-blue-primary-500/20 text-blue-primary-300 text-[13px] font-semibold px-4 py-1.5 rounded-full mb-6 tracking-wide">
          TRANSPARENT & FLEXIBLE
        </div>
        <h1 className="font-inter text-[36px] sm:text-[42px] lg:text-[56px] font-extrabold tracking-[-2px] leading-[1.1] mb-5">
          Simple, Fixed Fee AI Bookkeeping
        </h1>
        <p className="font-inter text-[18px] text-white/70 leading-[1.7] mb-10 max-w-[560px] mx-auto">
          Transparent pricing for Australian businesses. Scale up or down as you grow
          — no lock-in contracts, no hidden fees.
        </p>

        {/* Billing toggle */}
        <div className="inline-flex items-center gap-3 bg-white/10 rounded-full p-1.5">
          <button
            onClick={() => onToggle("monthly")}
            className={`px-6 py-2.5 rounded-full text-[14px] font-semibold transition-all duration-300 ${
              billingCycle === "monthly"
                ? "bg-white text-blue-primary-900 shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
                : "text-white/70 hover:text-white"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => onToggle("yearly")}
            className={`px-6 py-2.5 rounded-full text-[14px] font-semibold transition-all duration-300 flex items-center gap-2 ${
              billingCycle === "yearly"
                ? "bg-white text-blue-primary-900 shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
                : "text-white/70 hover:text-white"
            }`}
          >
            Yearly
            <span className="bg-green-500/20 text-green-400 text-[11px] font-bold px-2 py-0.5 rounded-full">
              Save 10%
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
